import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CardWrapper = styled.div`
  width: inherit;
  flex-direction: column;
  position: relative;
  background: ${COLORS.BgMain};
  border-radius: 16px;
  ${FONTS.XXS};

  p:only-child{
      display: none;
  }
`;

export const CardChildItem = styled.div<{text: string, isAvailable: boolean}>`
  width: 100%;
  display: ${p => p.isAvailable ? 'flex' : 'none'};
`;

export const CardChildLink = styled.a<{isPromoted: boolean}>`
  width: auto;
  color: ${p => p.isPromoted ? COLORS.Logo : COLORS.TextPrimary};
  ${FONTS.MediumS};
  line-height: 1.9;
  transition: color 0.3s ease;
  white-space: pre-wrap;
  border-radius: 12px;
  padding: 6px 8px;
`;

export const CategoryLink = styled.p`
  width: auto;
  color: ${COLORS.TextDisabled};
  ${FONTS.MediumXS};
  padding-bottom: 8px !important;
  padding-top: 8px !important;
`;
